import src from "IMAGE";
export default { src, width: 238, height: 215, blurWidth: 0, blurHeight: 0};
